export const offer = {
  checkoutUrl: 'https://the-argentine-mindset.impultienda.ar/checkout',
  priceToday: '$9 USD',
  priceTomorrow: '$69',
  spotsRemaining: 47,
  studentCount: '2,847+',
  satisfaction: '94%',
  ctaLabel: 'হ্যাঁ! এখনই দ্য আর্জেন্টাইন মাইন্ডসেট সিস্টেম আনলক করুন',
  ctaSubLabel: 'সাথে সাথেই অ্যাক্সেস · ৭ দিনের মানি-ব্যাক গ্যারান্টি'
};
export const accessPoints: string[] = ['৬০ সেকেন্ডেই ৬টি ভলিউম ডাউনলোড করুন', 'যেকোনো ডিভাইসে চলে (ফোন, ট্যাব, ল্যাপটপ)', 'লাইফটাইম অ্যাক্সেস (কখনো শেষ হয় না)', 'ইমেইল ডেলিভারি + নিরাপদ ক্লাউড স্টোরেজ', 'আজীবন আপডেট (নিয়মিত নতুন কনটেন্ট যোগ হয়)'];